import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { ContentShare } from '@ifeng/ui_pc_share';
import { rel } from '../../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class Caption extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            allowComment,
            joinNum,
            count,
            noffhFlag,
            title,
            dateTime,
            fhhAccountDetail,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            pcUrl,
            followUrl,
        } = content;

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        return (
            <div>
                <h1 className={styles.topic}>{title}</h1>
                <div className={styles.info}>
                    <p className={styles.time}>
                        <span className={styles.date}>{dateTime}</span>
                        <br />
                        <span style={{ verticalAlign: 'bottom' }}>
                            {!source && !fhhAccountDetail.weMediaName ? '' : '来源：'}
                        </span>
                        <span className={styles.publisher}>
                            {!fhhAccountDetail.weMediaName ? (
                                <span className={styles.source}>
                                    {sourceUrl && sourceUrl !== '' ? (
                                        <a href={sourceUrl} target="_blank" rel={rel}>
                                            {source}
                                        </a>
                                    ) : (
                                        <span>{source}</span>
                                    )}
                                </span>
                            ) : (
                                <span className={styles.source}>
                                    {noffhFlag ? (
                                        <span>{fhhAccountDetail.weMediaName}</span>
                                    ) : (
                                        <React.Fragment>
                                            <a
                                                href={`//feng.ifeng.com/author/${fhhAccountDetail.eAccountId}`}
                                                target="_blank"
                                                rel={rel}>
                                                {fhhAccountDetail.weMediaName}
                                            </a>
                                            <span className={styles.icon} />
                                        </React.Fragment>
                                    )}
                                </span>
                            )}
                        </span>
                    </p>
                    <div className={styles.share_box}>
                        <ContentShare shareInfo={shareInfo} />
                    </div>
                    {allowComment ? (
                        <div className={styles.comment_box}>
                            <h5 className={styles.comment}>
                                <a className={styles.joinNum} href={followUrl} target="_blank" rel={rel}>
                                    <span className={styles.num}>{joinNum}</span>
                                    <span className={styles.text}>人参与</span>
                                </a>
                                <a className={styles.commentNum} href={followUrl} target="_blank" rel={rel}>
                                    <span className={styles.num}>{count}</span>
                                    <span className={styles.text}>评论</span>
                                </a>
                            </h5>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className={styles.devide} />
            </div>
        );
    }
}

export default errorBoundary(Caption);
